/* eslint-disable indent */
import { apiPaths, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET (list object)
export const GET_ENV_SUCCESS = 'GET_ENV_SUCCESS'
export const GET_ENV_FAILURE = 'GET_ENV_FAILURE'

// ____________________________________________________________

/**
 * Get the list of all accounts and broadcast two types of events:
 * - GET_ACCOUNTS_SUCCESS: in case of success
 * - GET_ACCOUNTS_FAILURE: in case of failure.
 *
 * @returns {Promise<object>}
 */
export const getEnvironment = () => async (dispatch) => {
  const path = apiPaths.ENV_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] envActions.getEnvironment()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_ENV_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: GET_ENV_FAILURE,
    data: result.data
  })
}
